import React, { Component } from 'react';
import { Terminal } from './component';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import './App.css';

const image= require("./ranjit.jpg")
const name = '<Ranjit Shah/>'
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            command: ''
        };
    }
    render() {
        return (
            <div>
                <div className="container">
                    <div class="sonar-wrapper">
                        <div class="sonar-emitter">
                            <img id="profile" src={image}></img>
                            <div class="sonar-wave"></div>
                        </div>
                    </div>
                    <div className="title">{name}</div>
                    <div>
                        <Terminal command={this.state.command} />
                    </div>
                    <div className="tags-section">
                        <div className="tags-title">

                    <ul className="tags">
                    <li>
                                <a href="https://drive.google.com/file/d/169A1ZRC1lw2GZXPVOlH8dBzJcgxXalDq/view" >Click to Download Resume</a>
                            </li>
                    </ul>

                        </div>

                    </div>
                    <br></br>
                    <br></br>
                    <div className="tags-section">
                        <div className="tags-title">-> COMMAND LIST</div>
                        <ul className="tags">
                            <li>
                                <a href="#intro">Introduce Myself (intro)</a>
                            </li>
                            <li>
                                <a href="#edu">Education (edu)</a>
                            </li>
                            <li>
                                <a href="#lang">Programming Skill (pskill)</a>
                            </li>
                            <li>
                                <a href="#stskill">Development Skill (devskill)</a>
                            </li>
                            <li>
                                <a href="#sskill">Software Skill (sskill)</a>
                            </li>
                            <li>
                                <a href="#pskill">Projects (project)</a>
                            </li>
                            <li>
                                <a href="#exp">Experience (exp)</a>
                            </li>
                            <li>
                                <a href="#contact">Contact (contact)</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-section">
                    © 2020 Ranjit |  <a href="https://github.com/ranjitkshah"><GitHubIcon style={{ fontSize: 13 }} /></a> |{' '}
                    <a href="https://www.linkedin.com/in/ranjit-shah-b94b7a1a8/"> <LinkedInIcon style={{ fontSize: 14 }} /></a> |{' '}
                    <a href="https://dev.to/ranjitkshah">
                        Blog
                    </a>
                </div>
            </div>
        );
    }
}

export default App;
